import React, { createContext, useState, useContext, useEffect } from "react";
import { AuthContextState, AuthProviderProps, decodedJwtDataProps} from "../../utils/types";
import { checkAuth } from "../apis/auth-api/apiUrl";

const AuthContext = createContext<AuthContextState | undefined>(undefined);

export const AuthProvider : React.FC<AuthProviderProps> = ({children}) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [decodedJwtData, setDecodedJwtData] = useState<decodedJwtDataProps>({
        userId : 0, 
        profile_picture : '',
        fullname : '',
        email : '', 
        account_priv : [],
        iat : 0, 
        exp : 0
    });

    useEffect(()=>{
        async function verifyAuth() {
            try{
                const decodedJwt = await checkAuth();
                setDecodedJwtData(decodedJwt);
                setIsAuthenticated(true);
            }catch(e){
                setIsAuthenticated(false);
            }
            setLoading((false))
        }

        verifyAuth();
    }, []);


    function setJWTData () : Promise <boolean>{
        return new Promise(async(resolve, reject)=>{
            try{
                const decodedJwt = await checkAuth();
                setDecodedJwtData(decodedJwt);
                resolve(true);
            }catch(e){
                reject(false);
            }
        })
    }

    function logout(){
        localStorage.removeItem('token');
        localStorage.removeItem('auth_session_exp');
        setIsAuthenticated(false);
    }

    if(isAuthenticated){
        const exp = Number(localStorage.getItem('auth_session_exp') ?? 0);
        setInterval(()=>{
            const current_time = Math.floor(Date.now() / 1000)
            if(current_time >= exp){
                logout();
                setIsAuthenticated(false);
            } 
        }, 5000);
    }

    return (
        <AuthContext.Provider value={{isAuthenticated, loading, setIsAuthenticated, logout, decodedJwtData, setJWTData}}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);